import { createContext, useContext } from 'react'

import { type ModuleThemeColours } from './constants'

type ModuleThemeContextType = {
  moduleTheme: ModuleThemeColours
  setModuleTheme: (moduleTheme: ModuleThemeColours) => void
}

export const ModuleThemeContext = createContext<ModuleThemeContextType | undefined>(undefined)

export const useModuleTheme = (): ModuleThemeContextType => {
  const context = useContext(ModuleThemeContext)
  if (!context) {
    throw new Error('useModuleTheme must be used within a ModuleThemeProvider')
  }

  return context
}
